import { Action } from '@ngrx/store';

export const SET_COLOR = '[MAIN] Set';


export class SetColorAction implements Action {
  readonly type = SET_COLOR;
  constructor(public color: string ) {}
}

export type ColorActions =
  | SetColorAction;
